/* eslint-disable no-await-in-loop */
const baseUrl = Wiz.GetModuleServer()

const PROJECT_NAME = Wiz.globalSettings.globalConfig?.modelSetting?.folderName || 'SAAS'
const visualizationSetting = Wiz.globalSettings.dynamicModules.modules['visualization-cockpit']?.config
const MAX_LOD = visualizationSetting?.deviceDistanceConfig?.maxLod || 1000
const MIN_LOD = visualizationSetting?.deviceDistanceConfig?.minLod || 0
const headerComponentCode = visualizationSetting?.headerComponentCode

/** ************************************************ 设备标签 **************************************** */
let markerList = []
let deviceList = []
let textImgId = ''
let drawHandler

// 初始化数据
const initData = () => {
  markerList = []
  deviceList = []
  drawHandler = null
}

const getTextWidth = (text, font = '15px Arial') => {
  const canvas = document.createElement('canvas')
  const context = canvas.getContext('2d')
  context.font = font
  const metrics = context.measureText(text)
  return Math.ceil(metrics.width) + 20
}
// 标签点击
const markerClick = (data) => {
  const markInfo = markerList.find((item) => { return item.markerId === data.markerId })
  if (markInfo) {
    const openEvent = new CustomEvent('openComponent', {
      detail: {
        toCom: { code: headerComponentCode === 'CockpitHeaderDj' ? 'DeviceRealBasicInfoDJ' : 'DeviceRealBasicInfo', origin: 'tag', name: '设备基础信息' },
        type: 'tags',
        props: markInfo,
      },
    })
    window.dispatchEvent(openEvent)
  }
}

// 获取设备列表
const getDataList = async (player) => {
  const res = await axios({
    method: 'GET',
    url: `${baseUrl}/openapi/devices/paged-list/V1.0?token=portal_js`,
    params: {
      pageNo: 1,
      pageSize: 9999,
      level: ['A', 'B'].join(',')
    },
    headers: {
      'Content-Type': 'application/json; charset=utf8',
    },
    responseType: 'json',
  })
  if (res.data && res.data.data) {
    const tempList = res.data.data.items || []
    // let tempList = res.data.data.items || []
    // const arr = [
    //   { code: 'obj-13', name: 'obj-13', id: 1 },
    //   { code: 'obj-14', name: 'obj-14', id: 2 },
    //   { code: 'obj-15', name: 'obj-15', id: 3 },
    //   { code: 'obj-19', name: 'obj-19', id: 4 }
    // ]
    // tempList = [...arr, ...tempList]
    const pointMarkerList = []
    const codeList = []
    tempList.forEach((item) => {
      const prefix = item.code.slice(0, 4)
      if (prefix === '6760') {
        const newCode = item.code.slice(4, item.code.length)
        codeList.push(newCode)
      } else {
        codeList.push(item.code)
      }
    })
    const aabbRes = await player.Native.ModelTree.batchCalcItemAabb(codeList)
    tempList.forEach((tagInfo, index) => {
      const position = aabbRes[index]
      if (position && position.aabb) {
        const leftBottom = position.aabb.max
        const rightTop = position.aabb.min
        const pos = [
          (leftBottom[0] + rightTop[0]) / 2,
          (leftBottom[1] + rightTop[1]) / 2,
          (leftBottom[2] + rightTop[2]) / 2,
        ]
        pointMarkerList.push({
          id: tagInfo.id,
          code: tagInfo.code,
          name: tagInfo.name,
          pos
        })
      }
    })
    return pointMarkerList
  }
  return []
}

// 创建设备标签
const create = async (player) => {
  if (!player.Native) {
    return
  }
  // 初始化数据
  initData()
  drawHandler = new Promise(async (resolve) => {
    deviceList = await getDataList(player)
    if (!textImgId) {
      textImgId = await player.Native.GisMarker.loadImage(`data://../apps/${PROJECT_NAME}/digitalSimulation/img/icon-text.png`)
    }
    const options = deviceList.map((o) => {
      const len = getTextWidth(o.name)
      return {
        pos: o.pos,
        imgId: textImgId,
        imgSize: [len, 26],
        textFontSize: 15.0,
        breakWidth: -1,
        textColor: 0xffffffff,
        text: o.name || '',
        contentPadding: [10, 5, 0, 0],
        maxLod: MAX_LOD,
        minLod: MIN_LOD,
      }
    })
    const markerIds = await player.Native.GisMarker.batchCreate(options)
    const markers = []
    deviceList.forEach((item, index) => {
      markers.push({
        markerId: markerIds[index],
        id: item.id,
        code: item.code,
        name: item.name
      })
    })
    markerList = markers
    resolve()
  })
  player.Native.GisMarker.EventGisMarkerLClick.connect(markerClick)
}
const destroy = async (player) => {
  if (!player.Native) {
    return
  }
  await drawHandler
  const markerIds = markerList.map((item) => { return item.markerId })
  await player.Native.GisMarker.batchDestroy(markerIds)
  markerList = []
  player.Native.GisMarker.EventGisMarkerLClick.disconnect(markerClick)
}

const toggleDisplay = async (player, type) => {
  await drawHandler
  const markerIds = markerList.map((item) => { return item.markerId })
  const options = markerIds.map((id) => {
    return {
      markerId: id,
      options: {
        visible: type,
      }
    }
  })
  await player.Native.GisMarker.batchUpdate(options)
}

// 隐藏标签
const hidden = async (player) => {
  await toggleDisplay(player, false)
}

// 重新显示标签
const display = async (player) => {
  await toggleDisplay(player, true)
}
export default { create, destroy, hidden, display }
